import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import AccountContext from '../../services/AccountContext';
import memberService from '../../services/memberApi';

import styles from './Credits.module.less';

function Credits({ refreshCredits }) {
  //TODO Old code has an AB test for this.
  const minCreditsForCountDown = 1;

  const { memberId, isPremium, isSchoolAdmin } = useContext(AccountContext);
  const [credits, setCredits] = useState(-1);

  useEffect(() => {
    async function getCredits() {
      try {
        let response = await memberService.getMemberCredits(memberId);
        setCredits(response.Count);
      } catch (e) {
        // usually only happens after a page refresh when the token is not
        // available. The message wil be shown as soon as the user tries
        // to download
      }
    }
    if (!memberId) {
      setCredits(-1);
    }
    if (memberId && !isPremium) {
      getCredits();
    }
  }, [refreshCredits, memberId]);

  const resourceLink = isSchoolAdmin ? (
    <a className={styles.link} href="/my/school-admin/settings/?">
      &nbsp;Account settings.
    </a>
  ) : (
    <a className={styles.link} href="/pricing/">
      &nbsp;Upgrade for more.
    </a>
  );

  const contents =
    credits > -1 && credits <= minCreditsForCountDown ? (
      <div className={styles.creditContainer}>
        <span className={styles.creditText}>
          You have {credits} free resource{credits > 1 ? 's' : null} remaining.
          {resourceLink}
        </span>
      </div>
    ) : null;
  return contents;
}

Credits.propTypes = {
  refreshCredits: PropTypes.bool.isRequired,
};

export default Credits;
